function safeDashboardPath(path) {
    return typeof path === "string" && path.startsWith("/") && !path.startsWith("//") ? path : "/";
}

export function readImpersonationEntry(location, history) {
    if (location.pathname !== "/impersonate-login") return { token: "", nextPath: "/" };
    const params = new URLSearchParams(location.hash.replace(/^#/, ""));
    const entry = {
        token: params.get("token") || "",
        nextPath: safeDashboardPath(params.get("next")),
    };
    // Remove the credential before routing, analytics and lazy component loading.
    history.replaceState(history.state, "", location.pathname);
    return entry;
}

export function readImpersonationToken(location, history) {
    return readImpersonationEntry(location, history).token;
}

let entry = typeof window === "undefined"
    ? { token: "", nextPath: "/" }
    : readImpersonationEntry(window.location, window.history);

export function takeImpersonationEntry() {
    const result = entry;
    entry = { token: "", nextPath: "/" };
    return result;
}

export function takeImpersonationToken() {
    return takeImpersonationEntry().token;
}

export function resetIdentity(store) {
    store.commit("resetIdentity");
    store.commit("caporeparto", undefined);
    store.commit("requestpin", undefined);
}

export async function clearIdentityCaches(app, browser = window) {
    // clearStore does not refetch queries using the previous user's credentials.
    const client = app.$apolloProvider?.defaultClient;
    if (client) await client.clearStore();
    await app.$vlf.clear();
    const storage = browser.localStorage;
    for (const key of Object.keys(storage)) {
        if (!["vuex_user", "darkTheme"].includes(key)) storage.removeItem(key);
    }
    browser.sessionStorage.clear();
}

export function impersonationError(error) {
    if (error?.code === "MISSING_TOKEN") {
        return "Manca un collegamento valido. Apri l'accesso alla dashboard dalla scheda utente nell'amministrazione.";
    }
    if (error?.code === "CACHE_CLEANUP_FAILED") {
        return "Impossibile pulire i dati dell'accesso precedente. Premi Vai al login per riprovare la pulizia prima di accedere.";
    }
    if (error?.code === "INVALID_RESPONSE") {
        return "L'accesso non è stato completato. Torna alla scheda utente nell'amministrazione e apri un nuovo collegamento.";
    }
    if (!error?.response) {
        return "Impossibile completare l'accesso. Verifica la connessione, poi torna alla scheda utente nell'amministrazione e apri un nuovo collegamento.";
    }
    if ([400, 401, 403].includes(error.response.status)) {
        return "Il collegamento è scaduto, è già stato usato oppure l'accesso non è consentito. Torna alla scheda utente nell'amministrazione e apri un nuovo collegamento.";
    }
    return "Il servizio di accesso non è disponibile. Attendi qualche minuto, poi apri un nuovo collegamento dalla scheda utente nell'amministrazione.";
}

export async function startImpersonation(app, token, nextPath = "/") {
    resetIdentity(app.$store);
    try {
        await clearIdentityCaches(app);
    } catch (error) {
        throw Object.assign(new Error("Identity cleanup failed"), { code: "CACHE_CLEANUP_FAILED" });
    }
    if (!token) throw Object.assign(new Error("Missing impersonation token"), { code: "MISSING_TOKEN" });
    const response = await app.$work.impersonateLogin(token);
    const data = response?.data;
    if (!data?.token || !data.username || data.impersonation?.target !== "dashboard") {
        throw Object.assign(new Error("Invalid impersonation response"), { code: "INVALID_RESPONSE" });
    }
    app.$store.commit("setIdentity", data);
    // Reload discards component state, in-flight requests and in-memory caches.
    window.location.replace(safeDashboardPath(nextPath));
}
